import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=30b7d793"
import script from "./ResourceManage.vue?vue&type=script&lang=js"
export * from "./ResourceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports